import { type Revision, RevisionType } from '../types';
import { randomUUID } from '../utils';

/**
 * Create a descendant fork of a revision.
 * It contains all the content of the revision, but with a new ID, a new author, and points to the revision as its parent.
 */
export function createRevisionFork(
    revision: Revision,
    parts: Partial<Omit<Revision, 'conflicts'>> = {}
): Revision {
    if (revision.conflicts) {
        throw new Error('Cannot create a fork of a revision with conflicts');
    }

    const { pages, rootPages, files, variables, reusableContents, tags, ...rest } = parts;

    return {
        id: randomUUID(),
        type: RevisionType.Edits,
        parents: [revision.id],
        mergedFrom: undefined,
        edits: {},
        contentId: revision.contentId,
        pages: pages ?? structuredClone(revision.pages),
        rootPages: rootPages ?? structuredClone(revision.rootPages),
        files: files ?? structuredClone(revision.files),
        variables: variables ?? structuredClone(revision.variables),
        reusableContents: reusableContents ?? structuredClone(revision.reusableContents ?? {}),
        tags: tags ?? structuredClone(revision.tags ?? {}),
        ...rest,
    };
}
